import _ from 'lodash'
import { SORTORDER } from '../../utils/constants'

const ONGOING = 'on_going'
const ALLPROGRAMS = 'all_programs'
const AUTONOMOUS = 'AUTONOMOUS'
const DEFAULT = 'DEFAULT'

const MAX_PROGRAM_FILE_SIZE = 10000000
const INCENTIVE_VAL = '$0'
const INCENTIVE_KEY = 'CUSTOM'
const UPLOAD_OPTION_INDEX = -1
const incentive = {
  UPFRONT_DISCOUNT: 'Upfront Discount Incentive Value',
  SEASONAL_PERFORMANCE_INCENTIVES: 'Seasonal Performance Incentive Value',
  CUSTOM: 'Incentive Value'
}
const ALL = 'ALL'
const PROFILE_LIST = 'profileList'

const csipConfiguration = {
  CSIP_ENABLED: {
    name: 'csipEnabled',
    label: 'Csip Enabled'
  },
  CSIP_ENVOY_ENABLED: {
    name: 'csipEnvoyEnabled',
    label: 'Csip Envoy Enabled'
  },
  CSIP_IN_BANDREG_ENABLED: {
    name: 'csipInBandRegEnabled',
    label : 'In-Band Registration Enabled',
  },
  CSIP_DIRECT_CLIENT: {
    name: 'csipDirectClient',
    label: 'Csip Direct Client',
  }
}
const getProgramToggleOptions = (activeCount, allCount) => [
  {
    label: `On-going(${activeCount || 0})`,
    id: ONGOING,
  },
  {
    label: `All Programs(${allCount || 0})`,
    id: ALLPROGRAMS,
  },
]

const incentiveStructureOptions = {
  UPFRONT_DISCOUNT: {
    label: 'Upfront Discount Incentive',
    value: 'UPFRONT_DISCOUNT',
    header: 'Upfront Discount Incentive Value'
  },
  SEASONAL_PERFORMANCE_INCENTIVES: {
    label: 'Seasonal Performance Incentive',
    value: 'SEASONAL_PERFORMANCE_INCENTIVES',
    header: 'Seasonal Performance Incentive Value'
  },
  CUSTOM: {
    label: 'Custom',
    value: 'CUSTOM',
    header: 'Incentive Value'
  },
}

const CsipConfigOptions = {
  profileList: 'Profile',
  capabilityList: 'Der Capability Fields',
  settingsList: 'Der Settings Fields',
  controlList: 'Allowed Controls',
  telemetryList: 'Telemetry Fields',
  statusList: 'Der Status Fields'
}

const tableHeadings = (classes) => (
  [
    {
      id: 'programName',
      header: 'PROGRAM NAME',
      isLink: true,
      className: `${classes.tableHeading} ${classes.programName}`
    },
    {
      id: 'account_name',
      header: 'ACCOUNT NAME',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
      className: `${classes.tableHeading} ${classes.accountName}`
    },
    {
      id: 'systems_enrolled',
      header: 'SYSTEMS ENROLLED',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
      className: `${classes.tableHeading} ${classes.systems}`
    },
  ]
)

const getLocation = (stateList) => {
  return _.isObject(stateList)
    ? Object.entries(stateList).map(([key, value]) => ({
      label: `${value} ${key === ALL ? '' : ` - ${key}`}`,
      value: key,
    }))
    : []
}

const getCountries = (countryList) => {
  return _.isObject(countryList)
    ? Object.entries(countryList).map(([key, value]) => ({
      label: value,
      value: key,
    }))
    : []
}

const getUtilites = (utilityList) => {
  return utilityList.map((utility) => {
    return {
      label: _.get(utility, 'name', ''),
      value: _.get(utility, 'id', ''),
      states: _.get(utility, 'states', [])
    }
  })
}

const getAccount = (accountList) => {
  const list = []

  accountList.forEach((obj) => {
    list.push({
      label: _.get(obj, 'company_name', ''),
      value: _.get(obj, 'id', ''),
    })
  })

  return list
}

const adminProgramForm = (obj) => {
  return [
    [
      {
        id: 'name',
        name: 'name',
        label: 'Program name visible in Enlighten',
      },
      {
        id: 'adminName',
        name: 'adminName',
        label: 'Program name',
        disable: true,
      },
      {
        id: 'country',
        name: 'country',
        label: 'Country',
        type: 'select',
        options: getCountries(_.get(obj, 'countryList', [])),
      },
      {
        id: 'location',
        name: 'location',
        label: 'State',
        type: 'select',
        options: getLocation(_.get(obj, 'stateList', [])),
      },
      {
        id: 'utilityName',
        name: 'utilityName',
        label: 'Utility Name',
        type: 'select',
        options: getUtilites(_.get(obj, 'utilityList', [])),
      },
      {
        id: 'incentiveStructure',
        name: 'incentiveStructure',
        label: 'Incentive Structure',
        type: 'select',
        options: [
          {
            label: incentiveStructureOptions.UPFRONT_DISCOUNT.label,
            value: incentiveStructureOptions.UPFRONT_DISCOUNT.value,
          },
          {
            label:
              incentiveStructureOptions.SEASONAL_PERFORMANCE_INCENTIVES.label,
            value:
              incentiveStructureOptions.SEASONAL_PERFORMANCE_INCENTIVES.value,
          },
          {
            label: incentiveStructureOptions.CUSTOM.label,
            value: incentiveStructureOptions.CUSTOM.value,
          },
        ],
      },
      {
        id: 'incentiveValue',
        name: 'incentiveValue',
        label: '',
      },
    ],
    [
      {
        id: 'maxEnrollment',
        name: 'maxEnrollment',
        label: 'Maximum enrollment (Optional)',
        type: 'text',
      },
      {
        id: 'duration',
        name: 'duration',
        label: 'Program End Date (Optional)',
        type: 'date',
      },
    ],
    [
      {
        id: 'eventConfig',
        name: 'eventConfig',
        label: 'EVENT CONFIGURATION',
        type: 'multiSubHeading',
        divider: true
      },
      {
        id: 'cancelEventDefault',
        name: 'cancelEventDefault',
        label: 'Event Cancellation Allowed for Upcoming Events',
        multiValues: true,
        type: 'switch',
      },
      {
        id: 'stopEventDefault',
        name: 'stopEventDefault',
        label: 'Event Ending Allowed for Ongoing Events',
        multiValues: true,
        type: 'switch',
      },
      {
        id: 'eventOptDefault',
        name: 'eventOptDefault',
        label: 'Event opt in/ opt out capability',
        multiValues: true,
        type: 'switch',
      },
      {
        id: 'multioptionHeading',
        name: 'multioptionHeading',
        type: 'multioptionHeading'
      },
      {
        id: 'chargeEvent',
        name: 'chargeEvent',
        value: 'BATTERY_CHARGE',
        label: 'Charge Event',
        type: 'multioption',
        options: [{
          name: 'Charge From PV',
          value: 'Charge_From_PV'
        },
        {
          name: 'Charge From Net PV',
          value: 'Charge_From_NetPV'
        },
        {
          name: 'Charge From PV and Grid',
          value: 'Charge_From_PV_Grid'
        }]
      },
      {
        id: 'dischargeEvent',
        name: 'dischargeEvent',
        value: 'BATTERY_DISCHARGE',
        label: 'Discharge Event',
        type: 'multioption',
        options: [{
          name: 'Discharge to Load',
          value: 'Discharge_To_Load'
        },
        {
          name: 'Discharge to Net Load',
          value: 'Discharge_To_NetLoad'
        },
        {
          name: 'Discharge to Load and Grid',
          value: 'Discharge_To_Load_Grid'
        }]
      },
      {
        id: 'idleEvent',
        name: 'idleEvent',
        value: 'IDLE',
        label: 'Idle Event',
        type: 'multioption',
        options: []
      },
    ]
  ]
}

const superAdminProgramForm = (obj, isEdit) => {
  return [
    [
      {
        id: 'name',
        name: 'name',
        label: 'Program name visible in Enlighten',
      },
      {
        id: 'adminName',
        name: 'adminName',
        label: 'Program name',
      },
      {
        id: 'account',
        name: 'account',
        label: 'Select Account',
        type: 'select',
        options: getAccount(_.get(obj, 'accountList', [])),
      },
      {
        id: 'country',
        name: 'country',
        label: 'Country',
        type: 'select',
        options: getCountries(_.get(obj, 'countryList', [])),
      },
      {
        id: 'location',
        name: 'location',
        label: 'State',
        type: 'select',
        options: getLocation(_.get(obj, 'stateList', [])),
      },
      {
        id: 'utilityName',
        name: 'utilityName',
        label: 'Utility Name',
        type: 'select',
        options: getUtilites(_.get(obj, 'utilityList', [])),
      },
      {
        id: 'incentiveStructure',
        name: 'incentiveStructure',
        label: 'Incentive Structure',
        type: 'select',
        options: [
          {
            label: incentiveStructureOptions.UPFRONT_DISCOUNT.label,
            value: incentiveStructureOptions.UPFRONT_DISCOUNT.value,
          },
          {
            label:
              incentiveStructureOptions.SEASONAL_PERFORMANCE_INCENTIVES.label,
            value:
              incentiveStructureOptions.SEASONAL_PERFORMANCE_INCENTIVES.value,
          },
          {
            label: incentiveStructureOptions.CUSTOM.label,
            value: incentiveStructureOptions.CUSTOM.value,
          },
        ],
      },
      {
        id: 'incentiveValue',
        name: 'incentiveValue',
        label: '',
      },
    ],
    [
      {
        id: 'maxEnrollment',
        name: 'maxEnrollment',
        label: 'Maximum enrollment (Optional)',
        type: 'text',
      },
      {
        id: 'duration',
        name: 'duration',
        label: 'Program End Date (Optional)',
        type: 'date',
      },
      ...(isEdit
        ? [
          {
            id: 'enrollmentWebLink',
            name: 'enrollmentWebLink',
            label: 'Enrollment Web Link (Optional)',
            type: 'text',
          },
        ]
        : []),
    ],
    [
      {
        id: 'eventConfig',
        name: 'eventConfig',
        type: 'multiSubHeading',
        label: ['RECURRING', 'DEFAULT', 'PROGRAM'],
        divider: true
      },
      {
        id: 'cancelEvent',
        name: 'cancelEvent',
        label: 'Event Cancellation Allowed for Upcoming Events',
        type: 'multiSwitch',
        flagControls: [
          {
            id: 'cancelEventProgram',
            name: 'cancelEventProgram',
          },
          {
            id: 'cancelEventDefault',
            name: 'cancelEventDefault',
          },
          {
            id: 'cancelEventRecurring',
            name: 'cancelEventRecurring',
            type: AUTONOMOUS
          },
        ],
      },
      {
        id: 'stopEvent',
        name: 'stopEvent',
        label: 'Event Ending Allowed for Ongoing Events',
        type: 'multiSwitch',
        flagControls: [
          {
            id: 'stopEventProgram',
            name: 'stopEventProgram',
          },
          {
            id: 'stopEventDefault',
            name: 'stopEventDefault',
          },
          {
            id: 'stopEventRecurring',
            name: 'stopEventRecurring',
            type: AUTONOMOUS
          }
        ],
      },
      {
        id: 'eventOpt',
        name: 'eventOpt',
        label: 'Event opt in/ opt out capability',
        type: 'multiSwitch',
        flagControls: [
          {
            id: 'eventOptProgram',
            name: 'eventOptProgram',
          },
          {
            id: 'eventOptDefault',
            name: 'eventOptDefault',
          },
          {
            id: 'eventOptRecurring',
            name: 'eventOptRecurring',
            type: AUTONOMOUS
          },
        ],
      },
      {
        id: 'targetSocOverride',
        name: 'targetSocOverride',
        label: 'Target SoC Override',
        type: 'multiSwitch',
        flagControls: [
          {
            id: 'targetSocOverrideProgram',
            name: 'targetSocOverrideProgram',
          },
          {
            id: 'targetSocOverrideDefault',
            name: 'targetSocOverrideDefault',
          },
          {
            id: 'targetSocOverrideRecurring',
            name: 'targetSocOverrideRecurring',
            type: AUTONOMOUS
          },
        ],
      },
      {
        id: 'scheduledPowerOverride',
        name: 'scheduledPowerOverride',
        label: 'Scheduled Power Override',
        type: 'multiSwitch',
        flagControls: [
          {
            id: 'scheduledPowerOverrideProgram',
            name: 'scheduledPowerOverrideProgram',
          },
          {
            id: 'scheduledPowerOverrideDefault',
            name: 'scheduledPowerOverrideDefault',
          },
          {
            id: 'scheduledPowerOverrideRecurring',
            name: 'scheduledPowerOverrideRecurring',
            type: AUTONOMOUS
          },
        ],
      },
      {
        id: 'stormGuardOverride',
        name: 'stormGuardOverride',
        label: 'Enable Storm Guard Override',
        type: 'multiSwitch',
        flagControls: [
          {
            id: 'stormGuardOverrideProgram',
            name: 'stormGuardOverrideProgram',
          },
          {
            id: 'stormGuardOverrideDefault',
            name: 'stormGuardOverrideDefault',
          },
          {
            id: 'stormGuardOverrideRecurring',
            name: 'stormGuardOverrideRecurring',
            type: AUTONOMOUS
          },
        ],
      },
      {
        id: 'maxEventDuration',
        name: 'maxEventDuration',
        label: 'Maximum Event Duration (seconds)',
        type: 'text',
        flag: 'max_event_duration',
        inputs: ['maxEventDurationProgram', 'maxEventDurationDefault', 'maxEventDurationRecurring'],
      },
      {
        id: 'minEventDuration',
        name: 'minEventDuration',
        label: 'Minimum Event Duration (seconds)',
        type: 'text',
        flag: 'min_event_duration',
        inputs: ['minEventDurationProgram', 'minEventDurationDefault', 'minEventDurationRecurring'],
      },
      {
        id: 'helperText',
        name: 'helperText',
        type: 'text',
        divider: true
      },
      {
        id: 'controlType',
        name: 'controlType',
        label: 'Control Type',
        type: 'checkboxes',
        options: [{
          label: 'Local API',
          value: 'LOCAL_API'
        }, {
          label: 'Cloud API',
          value: 'CLOUD_API'
        }]
      },
      {
        id: 'functions',
        name: 'Functions',
        label: 'Functions',
        type: 'checkboxes',
        options: [{
          label: 'PV',
          value: 'PV'
        },
        {
          label: 'Battery',
          value: 'BATTERY'
        },
        {
          label: 'HP',
          value: 'HP'
        },
        {
          label: 'EVSE',
          value: 'EVSE'
        },
        {
          label: 'HVAC',
          value: 'HVAC'
        }]
      },
      {
        id: 'minimumeSw',
        name: 'minimumeSw',
        label: 'Minimum Envoy Software Version',
        type: 'multiText',
        options: [
          {
            name: 'minEswBattery',
            label: 'Battery',
            dependency: 'BATTERY'
          },
          {
            name: 'minEswExportLimit',
            label: 'Export Limit',
            dependency: 'export_limit'
          },
          {
            name: 'minEswPv',
            label: 'PV',
            dependency: 'PV'
          },
        ]
      },
      {
        id: 'evseControlType',
        name: 'evseControlType',
        value: 'evse_control_type',
        label: 'EVSE Control Type',
        type: 'evseControlType',
        hideSoc: true,
        options: [{
          name: 'VPP_API',
          value: 'VPP_API'
        }, {
          name: 'OCPP',
          value: 'OCPP'
        }],
      },
      {
        id: 'multioptionHeading',
        name: 'multioptionHeading',
        type: 'multioptionHeading'
      },
      {
        id: 'chargeEvent',
        name: 'chargeEvent',
        value: 'BATTERY_CHARGE',
        label: 'Charge Event',
        type: 'multioption',
        options: [{
          name: 'Charge From PV',
          value: 'Charge_From_PV'
        },
        {
          name: 'Charge From Net PV',
          value: 'Charge_From_NetPV'
        },
        {
          name: 'Charge From PV and Grid',
          value: 'Charge_From_PV_Grid'
        }]
      },
      {
        id: 'dischargeEvent',
        name: 'dischargeEvent',
        value: 'BATTERY_DISCHARGE',
        label: 'Discharge Event',
        type: 'multioption',
        options: [{
          name: 'Discharge to Load',
          value: 'Discharge_To_Load'
        },
        {
          name: 'Discharge to Net Load',
          value: 'Discharge_To_NetLoad'
        },
        {
          name: 'Discharge to Load and Grid',
          value: 'Discharge_To_Load_Grid'
        }]
      },
      {
        id: 'idleEvent',
        name: 'idleEvent',
        value: 'IDLE',
        label: 'Idle Event',
        type: 'multioption',
        options: [],
      },
      {
        id: 'pvCurtailment',
        name: 'pvCurtailment',
        value: 'pv_curtailment',
        label: 'PV Curtailment',
        type: 'multioption',
        options: [],
      },
      {
        id: 'exportLimit',
        name: 'exportLimit',
        value: 'export_limit',
        label: 'Export Limit',
        type: 'multioption',
        options: [],
      },
      {
        id: 'hpControl',
        name: 'hpControl',
        value: 'hp_control',
        label: 'HP Control',
        type: 'multioption',
        hideSoc: true,
        options: [{
          name: 'Mode 1',
          value: 'MODE_1'
        }, {
          name: 'Mode 2',
          value: 'MODE_2'
        }, {
          name: 'Mode 3',
          value: 'MODE_3'
        }, {
          name: 'Mode 4',
          value: 'MODE_4'
        }],
      },
      {
        id: 'evseControl',
        name: 'evseControl',
        value: 'evse_control',
        label: 'EVSE Control',
        type: 'multioption',
        hideSoc: true,
        options: [{
          name: 'Charge',
          value: 'Charge'
        }, {
          name: 'Dont Charge',
          value: 'Dont_Charge'
        }],
      },
      {
        id: 'hvacControl',
        name: 'hvacControl',
        value: 'hvac_control',
        label: 'HVAC Control',
        type: 'multioption',
        hideSoc: true,
        options: [{
          name: 'SETPOINT OFFSET',
          value: 'SETPOINT_OFFSET'
        }],
      },
      {
        id: 'minimumRateWatt',
        name: 'minimumRateWatt',
        label: 'Minimum Rate Watt (percent)',
        type: 'text',
        flag: 'minimum_rate_watt_percent'
      },
      {
        id: 'retryTimeInterval',
        name: 'retryTimeInterval',
        label: 'Command Retry Time Interval Post Start (seconds)',
        type: 'text',
        flag: 'command_retry_time_interval_post_start'
      },
      {
        id: 'eventLeadTime',
        name: 'eventLeadTime',
        label: 'Event Lead Time (seconds)',
        type: 'text',
        flag: 'event_lead_time'
      },
      {
        id: 'batteryLockConfig',
        name: 'batteryLockConfig',
        label: 'Battery Full-Backup mode Prior Hours',
        type: 'text',
        flag: 'battery_lock_config'
      },
      {
        id: 'activateRealTimeDispatch',
        name: 'activateRealTimeDispatch',
        label: 'Activate Real Time Dispatch',
        type: 'switch',
        disabled: true,
      },
      {
        id: 'enactEnabled',
        name: 'enactEnabled',
        label: 'Enact Enabled',
        type: 'switch',
      },
      {
        id: 'enableCollectTelemetry',
        name: 'enableCollectTelemetry',
        label: 'Enable Collect Telemetry',
        type: 'switch',
        flag: 'enable_collect_telemetry',
      },
      {
        id: 'enableForecast',
        name: 'enableForecast',
        label: 'Enable Forecast',
        type: 'switch',
        flag: 'enable_forecast',
      },
      {
        id: 'liveStreamTelemetryEnabled',
        name: 'liveStreamTelemetryEnabled',
        label: 'Live Stream Telemetry Enabled',
        type: 'switch',
      },
      {
        id: 'liveStreamTelemetryFrequency',
        name: 'liveStreamTelemetryFrequency',
        label: 'Live Stream Telemetry Frequency',
        type: 'text',
        flag: 'live_stream_telemetry_frequency',
        disabled: true,
        disableDependency: [
          'liveStreamTelemetryEnabled'
        ]
      },
      {
        id: 'liveStreamTelemetryCustomerName',
        name: 'liveStreamTelemetryCustomerName',
        label: 'Live Stream Telemetry Customer Name',
        type: 'text',
        flag: 'live_stream_telemetry_customer_name',
        disabled: true,
        disableDependency: [
          'liveStreamTelemetryEnabled'
        ]
      },
      {
        id: 'subHeading',
        name: 'subHeading',
        label: 'REPORTS',
        type: 'subHeading',
        divider: true
      },
      {
        id: 'programAndEvent',
        name: 'programAndEvent',
        label: 'Program and Events',
        type: 'switch'
      },
      {
        id: 'systemReports',
        name: 'systemReports',
        label: 'System Reports',
        disabled: true,
        type: 'switch'
      },
      {
        id: 'forecastingReports',
        name: 'forecastingReports',
        label: 'Forecasting Reports',
        disabled: true,
        type: 'switch'
      },
      {
        id: 'userReports',
        name: 'userReports',
        label: 'User Reports',
        type: 'switch',
        disabled: true
      },
    ],
    [
      {
        id: 'subHeading',
        name: 'subHeading',
        label: 'HOMEOWNER ENLIGHTEN APP BASED ENROLLMENT',
        type: 'subHeading',
        divider: true
      },
      {
        id: 'signatureTAndC',
        name: 'signatureTAndC',
        label: 'Input fields, Terms and Conditions, Signatures',
        type: 'switch'
      },
      {
        id: 'committedPower',
        name: 'committedPower',
        label: 'Committed power in program',
        type: 'switch',
      },
      {
        id: 'committedEnergy',
        name: 'committedEnergy',
        label: 'Committed energy in program',
        type: 'switch',
        divider: true
      },
      {
        id: 'siteGrid',
        name: 'siteGrid',
        label: 'Site On Grid/ Off Grid Feature',
        type: 'switch',
        disabled: true,
      },
      {
        id: 'reserveSoc',
        name: 'reserveSoc',
        label: 'Battery Reserve SoC configurability',
        type: 'switch',
      },
      {
        id: 'potentialEarning',
        name: 'potentialEarning',
        label: 'Potential earnings applicable for program',
        type: 'switch',
      },
      {
        id: 'incentiveCalc',
        name: 'incentiveCalc',
        label: 'Incentive Calculation Formulae',
        type: 'switch',
      },
      {
        id: 'installerIntake',
        name: 'installerIntake',
        label: 'Installer Intake Portal based Enrollment',
        type: 'switch',
      },
      {
        id: 'customerSupportView',
        name: 'customerSupportView',
        label: 'Customer Support View',
        type: 'switch',
      },
      {
        id: 'subHeading',
        name: 'subHeading',
        label: 'SYSTEM ENROLLMENT',
        type: 'subHeading',
        divider: true
      },
      {
        id: 'enrolmentOptions',
        name: 'enrolmentOptions',
        label: 'Systems Enrollment Options',
        type: 'multiButton'
      },
      {
        id: 'systemAccessList',
        name: 'systemAccessList',
        label: 'System access authorization',
        type: 'checkboxes',
        options: [{
          label: 'OWNER',
          value: 'OWNER'
        },
        {
          label: 'HOST',
          value: 'HOST'
        }]
      },
      {
        id: 'unsupporedSolarMicros',
        name: 'unsupporedSolarMicros',
        label: 'Unsupported Micro Models',
        type: 'text',
        flag: 'unsuppored_solar_micros'
      },
      {
        id: 'minSiteStage',
        name: 'minSiteStage',
        label: 'Minimum Allowed Site Stage [0-5]',
        type: 'text',
        flag: 'min_site_stage'
      },
      {
        id: 'allowedSites',
        name: 'allowedSites',
        label: 'Allowed Sites',
        type: 'text',
        flag: 'allowed_sites'
      },
      {
        id: 'allowedZipCodes',
        name: 'allowedZipCodes',
        label: 'Allowed Zip Codes',
        type: 'text',
        flag: 'allowed_zip'
      },
      {
        id: 'pcuBinWidth',
        name: 'pcuBinWidth',
        label: 'Pcu Bin Width (seconds)',
        type: 'text',
        flag: 'pcu_bin_width'
      },
      {
        id: 'pcuPollingInterval',
        name: 'pcuPollingInterval',
        label: 'Pcu Polling Interval (seconds)',
        type: 'text',
        flag: 'pcu_polling_interval'

      },
      {
        id: 'rgmBinWidth',
        name: 'rgmBinWidth',
        label: 'Rgm Bin Width (seconds)',
        type: 'text',
        flag: 'rgm_bin_width'
      },
      {
        id: 'rgmPollingInterval',
        name: 'rgmPollingInterval',
        label: 'Rgm Polling Interval (seconds)',
        type: 'text',
        flag: 'rgm_polling_interval'
      },
      {
        id: 'reportingIntervalPeriod',
        name: 'reportingIntervalPeriod',
        label: 'Reporting Interval Period (seconds)',
        type: 'text',
        flag: 'reporting_interval_period'
      },
      {
        id: 'sftpEnrollment',
        name: 'sftpEnrollment',
        label: 'Sftp Enrollment Files To Energyhub',
        type: 'switch',
      },
      {
        id: 'autounenrollment',
        name: 'autounenrollment',
        label: 'Auto Unenroll Sites',
        type: 'switch',
      },
      {
        id: 'programStandardization',
        name: 'programStandardization',
        label: 'Program Standardization',
        type: 'switch',
        disabled: true
      },
      {
        id: 'enhoAppIntake',
        name: 'enhoAppIntake',
        label: 'Enho App Intake',
        type: 'switch',
        divider: true
      },
      {
        id: 'enrolledHomeOwnerexp',
        name: 'enrolledHomeOwnerexp',
        label: 'Enrolled HomeOwner experience',
        type: 'switch',
      },
      {
        id: 'solarHomeOwner',
        name: 'solarHomeOwner',
        label: 'Solar Only Homeowner experience',
        type: 'switch',
      },
      {
        id: 'solarStorageHomeOwner',
        name: 'solarStorageHomeOwner',
        label: 'Solar Storage Homeowner experience',
        type: 'switch',
      },
      {
        id: 'storageOnlyHomeOwner',
        name: 'storageOnlyHomeOwner',
        label: 'Storage Only Homeowner experience',
        type: 'switch',
      },
      {
        id: 'syncEnrollments',
        name: 'syncEnrollments',
        label: 'Sync Enrollments',
        type: 'switch',
      },
      {
        id: 'enableBulkEvent',
        name: 'enableBulkEvent',
        label: 'Enable Bulk Event Dispatch',
        type: 'switch', 
      },
      {
        id: 'subHeading',
        name: 'subHeading',
        label: 'THIRD PARTY CONTROL',
        type: 'subHeading',
        divider: true
      },
      {
        id: 'externalSteeringMode',
        name: 'externalSteeringMode',
        label: 'External Steering Mode',
        type: 'switch',
        flag: 'external_steering_mode'
      },
      {
        id: 'cfg',
        name: 'cfg',
        label: 'CFG',
        type: 'switch',
        flag: 'cfg'
      },
      {
        id: 'dtg',
        name: 'dtg',
        label: 'DTG',
        type: 'switch',
        flag: 'dtg'
      },
      {
        id: 'tpcName',
        name: 'tpcName',
        label: 'TPC Name',
        type: 'text',
        flag: 'tpc_name'
      },
      {
        id: 'tpcProgram',
        name: 'tpcProgram',
        label: 'TPC Program',
        type: 'text',
        flag: 'tpc_program'
      },
      {
        id: 'rsoc',
        name: 'rsoc',
        label: 'RSOC [0-100%]',
        type: 'text',
        flag: 'rsoc'
      },
      {
        id: 'vls',
        name: 'vls',
        label: 'VLS [5-25%]',
        type: 'text',
        flag: 'vls'
      }
    ],
    [
      {
        id: 'openAdr',
        name: 'openAdr',
        label: 'OpenADR 2.0b service for program',
        type: 'switch',
        divider: true,

      },
      {
        id: 'openADREnrollmentService',
        name: 'openADREnrollmentService',
        label: 'OpenADR Enrollment Service',
        type: 'switch',
        disabled: true,
        disableDependency: [
          'openAdr'
        ]
      },
      {
        id: 'openADREventService',
        name: 'openADREventService',
        label: 'OpenADR Event Service',
        type: 'switch',
        disabled: true,
        disableDependency: [
          'openAdr'
        ]
      },
      {
        id: 'openADRReportService',
        name: 'openADRReportService',
        label: 'OpenADR Report Service',
        type: 'switch',
        disabled: true,
        disableDependency: [
          'openAdr'
        ]
      },
      {
        id: 'openADROptOutService',
        name: 'openADROptOutService',
        label: 'OpenADR OptOut Service',
        type: 'switch',
        disabled: true,
        disableDependency: [
          'openAdr'
        ]
      }
    ],
  ]
}

export const validationLabel = {
  SYSTEM_OWNER: 'System Owner Validation',
  PV_INSTALLER: 'PV Installer',
  PV_SYSTEM_MAINTAINER: 'PV System Maintainer',
  HO_ACCESS_TOKEN: 'HO Access Token Validation',
  PRE_APPROVED_AUTH: 'Pre Approved Auth',
}

export const PRE_APPROVED_AUTH = 'PRE_APPROVED_AUTH'

const featureInCreation = ['eventConfig', 'cancelEvent', 'stopEvent', 'eventOpt', 'cancelEventDefault', 'stopEventDefault', 'eventOptDefault', 'multioptionHeading', 'chargeEvent', 'dischargeEvent', 'idleEvent']

const subTypeValidityChecker = {
  'BATTERY_CHARGE': ['Charge_From_PV', 'Charge_From_NetPV', 'Charge_From_PV_Grid'],
  'BATTERY_DISCHARGE': ['Discharge_To_Load', 'Discharge_To_NetLoad', 'Discharge_To_Load_Grid'],
  'IDLE': []
}

const programSettingsLabel = {
  PROGRAM_INFORMATION: 'Program_Information',
  ENROLLMENT_CONFIGURATION: 'Enrollment_Configuration',
  DASHBOARD_WIDGETS: 'Dashboard Widgets',
  PROGRAM_DETAILS: 'Program_Details'
}

const getProgramSettingsToggleOptions = () => [
  {
    label: 'Program Information',
    id: programSettingsLabel.PROGRAM_INFORMATION
  },
  {
    label: 'Program Details',
    id: programSettingsLabel.PROGRAM_DETAILS
  },
  {
    label: 'Enrollment Configuration',
    id: programSettingsLabel.ENROLLMENT_CONFIGURATION
  },
  {
    label: 'Dashboard Widgets',
    id: programSettingsLabel.DASHBOARD_WIDGETS
  }
]

const batteryEventSubTypes = ['Charge_From_PV', 'Charge_From_NetPV', 'Charge_From_PV_Grid', 'Discharge_To_Load', 'Discharge_To_NetLoad', 'Discharge_To_Load_Grid', 'Idle']
const hpEventSubTypes = ['MODE_1', 'MODE_2', 'MODE_3', 'MODE_4']
const evseEventSubTypes = ['Charge', 'Dont_Charge']
const hvacEventSubTypes = ['SETPOINT_OFFSET']

const CONTROL_TYPES = {
  LOCAL_API: 'LOCAL API',
  CLOUD_API: 'CLOUD API'
}

const LOCAL_API = 'LOCAL_API'
const CLOUD_API = 'CLOUD_API'
const OWNER = 'OWNER'
const HOST = 'HOST'

export {
  tableHeadings,
  ONGOING,
  ALLPROGRAMS,
  AUTONOMOUS,
  DEFAULT,
  getProgramToggleOptions,
  getProgramSettingsToggleOptions,
  adminProgramForm,
  superAdminProgramForm,
  incentiveStructureOptions,
  CsipConfigOptions,
  PROFILE_LIST,
  csipConfiguration,
  MAX_PROGRAM_FILE_SIZE,
  INCENTIVE_VAL,
  INCENTIVE_KEY,
  UPLOAD_OPTION_INDEX,
  getUtilites,
  incentive,
  subTypeValidityChecker,
  featureInCreation,
  programSettingsLabel,
  batteryEventSubTypes,
  hpEventSubTypes,
  evseEventSubTypes,
  hvacEventSubTypes,
  CONTROL_TYPES,
  CLOUD_API,
  LOCAL_API,
  OWNER,
  HOST
}
